import React, {useEffect, useState} from "react";

import axios from "config/axiosConfig";
import {useLocation, useNavigate} from "react-router-dom";
import DatePicker from "react-datepicker";
import {format} from "date-fns-tz";
import 'react-datepicker/dist/react-datepicker.css';
import {formatDateParam} from "../../util/helpers";

export default function Detail() {
    const [content, setContent] = useState({messageType: "INFORMATION", sendType: "IMMEDIATE", recurringType: "DAILY"});

    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search); // 쿼리 파라미터 추출
    const id = queryParams.get("id");

    const days = ["월", "화", "수", "목", "금", "토", "일"];
    const dayCodes = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

    const requestData = () => {
        if (id !== null && id !== "") {
            axios.get(`/admin/push/messages/${id}`)
                .then((res) => {
                    if (res.data.schedule && res.data.schedule.sendAt) {
                        res.data.scheduleSendAt = new Date(res.data.schedule.sendAt);
                    }

                    if (res.data.recurring) {
                        if (res.data.recurring.recurringType) {
                            res.data.recurringType = res.data.recurring.recurringType;
                        }
                        if (res.data.recurring.startDate) {
                            res.data.recurringStartDate = res.data.recurring.startDate;
                        }
                        if (res.data.recurring.endDate) {
                            res.data.recurringEndDate = res.data.recurring.endDate;
                        }
                        if (res.data.recurring.sendTime) {
                            const [hours, minutes, seconds] = res.data.recurring.sendTime.split(":").map(Number);
                            const now = new Date(); // 오늘 날짜
                            res.data.recurringSendTime = new Date(
                                now.getFullYear(),
                                now.getMonth(),
                                now.getDate(),
                                hours,
                                minutes,
                                seconds
                            );
                        }
                        if (res.data.recurring.monthlyEntities.length > 0) {
                            res.data.recurringSendMonthDays = res.data.recurring.monthlyEntities.map((item) => item.sendMonthDay )
                        }

                        if (res.data.recurring.weeklyEntities.length > 0) {
                            res.data.recurringDaysOfWeeks = res.data.recurring.weeklyEntities.map((item) => item.dayOfWeek )
                        }
                    }

                    setContent(res.data);
                });
        }
    }

    const requestSave = () => {
        (async () => {
            if (!content.title?.trim()) {
                alert("제목을 입력해주세요.");
                return;
            }
            if (!content.content?.trim()) {
                alert("내용을 입력해주세요.");
                return;
            }
            if (content.sendType === "SCHEDULED" && !content.scheduleSendAt) {
                alert("예약 날짜/시간을 입력해주세요.");
                return;
            }
            if (content.sendType === "RECURRING") {
                if (!content.recurringStartDate) {
                    alert("시작일을 입력해주세요.");
                    return;
                }
                if (!content.recurringSendTime) {
                    alert("발송시간을 입력해주세요.");
                    return;
                }
                if (content.recurringType === "WEEKLY" && content.recurringDaysOfWeeks.length <= 0) {
                    alert("요일을 선택해주세요.");
                    return;
                }
                if (content.recurringType === "MONTHLY" && content.recurringSendMonthDays.length <= 0) {
                    alert("월/일을 선택해주세요.");
                    return;
                }
            }

            const params = {
                messageType: content.messageType,
                sendType: content.sendType,
                title: content.title,
                content: content.content,
                link: content.link,
                membershipType: content.membershipType,
                daysAfterJoin: content.daysAfterJoin,
                daysAfterLastLogin: content.daysAfterLastLogin,
                scheduleSendAt: formatDateParam(content.scheduleSendAt),
                recurringType: content.recurringType,
                recurringStartDate: content.recurringStartDate,
                recurringEndDate: content.recurringEndDate ?? "9999-12-31",
                recurringSendTime: formatDateParam(content.recurringSendTime, "HH:mm"),
                recurringDaysOfWeeks: content.recurringDaysOfWeeks,
                recurringSendMonthDays: (content.recurringSendMonthDays ?? []).sort(),
            }

            try {
                if (id === null || id === "") {
                    let savedRes = await axios.post(`/admin/push/messages`, JSON.stringify(params));
                    if (savedRes.status === 200) {
                        alert('저장 되었습니다.');
                        navigate(-1);
                    }
                } else {
                    let savedRes = await axios.put(`/admin/push/messages/${id}`, JSON.stringify(params));
                    if (savedRes.status === 200) {
                        alert('수정 되었습니다.');
                        navigate(-1);
                    }
                }
            } catch (err) {
                console.error(err);
                alert('저장 중 오류가 발생했습니다.');
            }
        })();
    }

    const requestDelete = (id) => {
        if (window.confirm("삭제 하시겠습니까?")) {
            axios.delete(`/admin/push/messages/${id}`)
                .then((res) => {
                    alert('삭제 되었습니다.');
                    navigate(-1);
                });
        }
    }

    const requestSendPushTest = () => {
        (async () => {
            if (!content.title?.trim()) {
                alert("제목을 입력해주세요.");
                return;
            }
            if (!content.content?.trim()) {
                alert("내용을 입력해주세요.");
                return;
            }

            const params = {
                messageType: content.messageType,
                title: content.title,
                content: content.content,
                link: content.link
            }

            let savedRes = await axios.post(`/admin/push/messages/send-test`, JSON.stringify(params));
            if (savedRes.status === 200) {
                alert('발송 되었습니다.');
            }
        })();
    }

    const requestSendPush = () => {
        (async () => {
            if (!content.title?.trim()) {
                alert("제목을 입력해주세요.");
                return;
            }
            if (!content.content?.trim()) {
                alert("내용을 입력해주세요.");
                return;
            }

            const params = {
                messageType: content.messageType,
                sendType: content.sendType,
                title: content.title,
                content: content.content,
                link: content.link,
                membershipType: content.membershipType,
            }

            let savedRes = await axios.post(`/admin/push/messages/send`, JSON.stringify(params));
            if (savedRes.status === 200) {
                alert('발송 되었습니다.');
            }
        })();
    }

    const toggleDay = (code) => {
        setContent((prev) => {
            if (prev.recurringDaysOfWeeks === undefined) {
                prev.recurringDaysOfWeeks = [];
            }

            if (prev.recurringDaysOfWeeks.includes(code))
                return { ...prev, recurringDaysOfWeeks: prev.recurringDaysOfWeeks.filter((d) => d !== code) };
            const isSelected = prev.recurringDaysOfWeeks.includes(code);
            const updated = isSelected
                ? prev.recurringDaysOfWeeks.filter((d) => d !== code)
                : [...prev.recurringDaysOfWeeks, code];

            return { ...prev, recurringDaysOfWeeks: updated };
        });
    };

    useEffect(() => {
        requestData()
    }, []);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">푸시메시지 - 상세</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <p className="lead">메시지 설정</p>
                            <div className="row">
                                <div className="card card-secondary col-sm-12">
                                    <div className="card-body">
                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>푸시 타입</label>
                                            <div className="col-sm-10">
                                                <select className="form-control"
                                                        style={{width: '100px', marginRight: '10px'}}
                                                        onChange={e => {
                                                            setContent({...content, messageType: e.target.value});
                                                        }}
                                                        value={content.messageType}>
                                                    <option value="INFORMATION">정보성</option>
                                                    <option value="MARKETING">광고성</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>제목</label>
                                            <div className="col-sm-10">
                                                <input type="text"
                                                       className="form-control"
                                                       onChange={event => {
                                                           setContent({...content, title: event.target.value});
                                                       }}
                                                       value={content.title ?? ""}
                                                />
                                            </div>
                                        </div>

                                        <div className="row" style={{ marginTop: "10px" }}>
                                            <label className="col-form-label col-sm-1" style={{ marginLeft: "8px" }}>
                                                내용
                                            </label>
                                            <div className="col-sm-10">
                                                <textarea
                                                    className="form-control"
                                                    rows={4}
                                                    onChange={event => {
                                                        setContent({ ...content, content: event.target.value });
                                                    }}
                                                    value={content.content ?? ""}
                                                />
                                            </div>
                                        </div>

                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>링크</label>
                                            <div className="col-sm-10">
                                                <input type="text"
                                                       className="form-control"
                                                       onChange={event => {
                                                           setContent({...content, link: event.target.value});
                                                       }}
                                                       value={content.link ?? ""}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="content" style={{marginTop: "20px"}}>
                        <div className="container-fluid">
                            <p className="lead">타켓 설정</p>
                            <div className="row">
                                <div className="card card-secondary col-sm-12">
                                    <div className="card-body">

                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>전송 방식</label>
                                            <div className="col-sm-10">
                                                <select className="form-control"
                                                        style={{width: '200px', marginRight: '10px'}}
                                                        onChange={e => {
                                                            const newSendType = e.target.value;
                                                            setContent(prev => ({...prev, sendType: newSendType}));
                                                        }}
                                                        value={content.sendType}>
                                                    <option value="IMMEDIATE">즉시 발송</option>
                                                    <option value="SCHEDULED">날짜/시간 예약 발송</option>
                                                    <option value="RECURRING">주기적 반복 발송</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>요금제</label>
                                            <div className="col-sm-10">
                                                <select className="form-control"
                                                        style={{width: '200px', marginRight: '10px'}}
                                                        onChange={e => {
                                                            setContent({...content, membershipType: e.target.value});
                                                        }}
                                                        value={content.membershipType}>
                                                    <option value="">전체</option>
                                                    <option value="BASIC">BASIC</option>
                                                    <option value="BUSINESS">BUSINESS</option>
                                                </select>
                                            </div>
                                        </div>

                                        {content.sendType !== "IMMEDIATE" && (
                                            <div className="row" style={{marginTop: "10px"}}>
                                                <label className="col-form-label col-sm-1"
                                                       style={{marginLeft: "8px"}}>가입일 0일이후</label>
                                                <div className="col-sm-10">
                                                    <div style={{display: "flex", alignItems: "center"}}>
                                                        <input type="text" style={{width: "100px", textAlign: "right"}}
                                                               className="form-control"
                                                               onChange={e => {
                                                                   const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                                                   setContent({...content, daysAfterJoin: onlyNums});
                                                               }}
                                                               value={content.daysAfterJoin ?? ""}
                                                        />
                                                        <span style={{marginLeft: "8px", color: "darkgray"}}>(일 단위 입력)</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {content.sendType !== "IMMEDIATE" && (
                                            <div className="row" style={{marginTop: "10px"}}>
                                                <label className="col-form-label col-sm-1"
                                                       style={{marginLeft: "8px"}}>최근접속일 0일이후</label>
                                                <div className="col-sm-10">
                                                    <div style={{display: "flex", alignItems: "center"}}>
                                                        <input type="text" style={{width: "100px", textAlign: "right"}}
                                                               className="form-control"
                                                               onChange={e => {
                                                                   const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                                                   setContent({...content, daysAfterLastLogin: onlyNums});
                                                               }}
                                                               value={content.daysAfterLastLogin ?? ""}
                                                        />
                                                        <span style={{marginLeft: "8px", color: "darkgray"}}>(일 단위 입력)</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {content.sendType === "SCHEDULED" && (
                        <section className="content" style={{ marginTop: "20px" }}>
                            <div className="container-fluid">
                                <p className="lead">날짜/시간 설정</p>
                                <div className="row">
                                    <div className="card card-secondary col-sm-12">
                                        <div className="card-body">
                                            <div className="row" style={{ marginTop: "10px" }}>
                                                <label className="col-form-label col-sm-1" style={{ marginLeft: "8px" }}>
                                                    예약 날짜/시간
                                                </label>
                                                <div className="col-sm-10" style={{ paddingTop: "4px" }}>
                                                    <DatePicker
                                                        dateFormat="yyyy-MM-dd HH:mm"
                                                        dateFormatCalendar="yyyy년 MM월"
                                                        showTimeSelect
                                                        timeIntervals={30}
                                                        locale="ko"
                                                        selected={content.scheduleSendAt}
                                                        onChange={(date) => {
                                                            setContent({ ...content, scheduleSendAt: date });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    )}

                    {content.sendType === "RECURRING" && (
                        <section className="content" style={{marginTop: "20px"}}>
                            <div className="container-fluid">
                                <p className="lead">반복주기 설정</p>
                                <div className="row">
                                    <div className="card card-secondary col-sm-12">
                                        <div className="card-body">

                                            <div className="row" style={{marginTop: "10px"}}>
                                                <label className="col-form-label col-sm-1"
                                                       style={{marginLeft: "8px"}}>반복주기</label>
                                                <div className="col-sm-10">
                                                    <select className="form-control"
                                                            style={{width: '200px', marginRight: '10px'}}
                                                            onChange={e => {
                                                                setContent({...content, recurringType: e.target.value});
                                                            }}
                                                            value={content.recurringType}>
                                                        <option value="DAILY">매일</option>
                                                        <option value="WEEKLY">매주</option>
                                                        <option value="MONTHLY">매월</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="row" style={{ marginTop: "10px" }}>
                                                <label className="col-form-label col-sm-1" style={{ marginLeft: "8px" }}>
                                                    시작일
                                                </label>
                                                <div className="col-sm-10" style={{ paddingTop: "4px" }}>
                                                    <DatePicker
                                                        dateFormat="yyyy-MM-dd"
                                                        dateFormatCalendar="yyyy년 MM월"
                                                        locale="ko"
                                                        selected={content.recurringStartDate}
                                                        onChange={(date) => {
                                                            setContent({ ...content, recurringStartDate: format(date, 'yyyy-MM-dd') });
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row" style={{ marginTop: "10px" }}>
                                                <label className="col-form-label col-sm-1" style={{ marginLeft: "8px" }}>
                                                    종료일
                                                </label>
                                                <div className="col-sm-10" style={{ paddingTop: "4px" }}>
                                                    <DatePicker
                                                        dateFormat="yyyy-MM-dd"
                                                        dateFormatCalendar="yyyy년 MM월"
                                                        locale="ko"
                                                        selected={content.recurringEndDate}
                                                        onChange={(date) => {
                                                            setContent({ ...content, recurringEndDate: format(date, 'yyyy-MM-dd') });
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row" style={{ marginTop: "10px" }}>
                                                <label className="col-form-label col-sm-1" style={{ marginLeft: "8px" }}>
                                                    발송시간
                                                </label>
                                                <div className="col-sm-10">
                                                    <DatePicker
                                                        selected={content.recurringSendTime}
                                                        onChange={(date) => {
                                                            setContent({ ...content, recurringSendTime: date });
                                                        }}
                                                        showTimeSelect
                                                        showTimeSelectOnly
                                                        timeIntervals={30}
                                                        dateFormat="HH:mm"
                                                        timeCaption="시간"
                                                        locale="ko"
                                                    />
                                                </div>
                                            </div>

                                            {
                                                content.recurringType && content.recurringType === "WEEKLY" && (
                                                    <div className="row" style={{ marginTop: "10px" }}>
                                                        <label className="col-form-label col-sm-1" style={{ marginLeft: "8px" }}>
                                                            요일선택
                                                        </label>
                                                        <div className="col-sm-10">
                                                            <div style={{ display: "flex", gap: "8px" }}>
                                                                {days.map((day, i) => {
                                                                    const code = dayCodes[i];
                                                                    const isSelected = content.recurringDaysOfWeeks?.includes(code) ?? false;
                                                                    return (
                                                                        <button
                                                                            key={code}
                                                                            onClick={() => toggleDay(code)}
                                                                            style={{
                                                                                padding: "8px 12px",
                                                                                borderRadius: "6px",
                                                                                border: "1px solid #ccc",
                                                                                backgroundColor: isSelected ? "#007bff" : "#fff",
                                                                                color: isSelected ? "#fff" : "#000",
                                                                                cursor: "pointer"
                                                                            }}>
                                                                            {day}
                                                                        </button>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }

                                            {
                                                content.recurringType && content.recurringType === "MONTHLY" && (
                                                    <div className="row" style={{marginTop: "10px"}}>
                                                        <label className="col-form-label col-sm-1" style={{marginLeft: "8px"}}>월/일 선택</label>
                                                        <div className="col-sm-10" style={{paddingTop: "4px"}}>
                                                            <DatePicker
                                                                dateFormat="MM-dd"
                                                                onChange={(date) => {
                                                                    if (!date) return;
                                                                    console.log("date: " + date);
                                                                    const dayStr = format(date, 'MM-dd');
                                                                    console.log("dayStr: " + dayStr);
                                                                    setContent((prev) => {
                                                                        if (prev.recurringSendMonthDays === undefined) {
                                                                            prev.recurringSendMonthDays = [];
                                                                        }
                                                                        const alreadySelected = prev.recurringSendMonthDays.includes(dayStr);
                                                                        if (alreadySelected) {
                                                                            alert("이미 선택된 월/일 입니다.");
                                                                            return prev;
                                                                        }
                                                                        const updatedDays= [...prev.recurringSendMonthDays, dayStr];
                                                                        return { ...prev, recurringSendMonthDays: updatedDays };
                                                                    });
                                                                }}
                                                                renderCustomHeader={({ monthDate, changeMonth }) => (
                                                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                        <button onClick={() => changeMonth(monthDate.getMonth() - 1)}>{'<'}</button>
                                                                        <span style={{ margin: '0 10px' }}>{monthDate.toLocaleString('default', { month: 'long' })}</span>
                                                                        <button onClick={() => changeMonth(monthDate.getMonth() + 1)}>{'>'}</button>
                                                                    </div>
                                                                )}
                                                            />
                                                            {/* 선택된 날짜 노출 + 제거 버튼 */}
                                                            <div style={{ marginTop: "10px" }}>
                                                                {content.recurringSendMonthDays && content.recurringSendMonthDays.map((day) => (
                                                                    <div key={day} style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                                                                        <span style={{ marginRight: "8px" }}>{day}</span>
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => {
                                                                                setContent((prev) => ({
                                                                                    ...prev,
                                                                                    recurringSendMonthDays: prev.recurringSendMonthDays.filter((d) => d !== day),
                                                                                }));
                                                                            }}
                                                                            style={{
                                                                                backgroundColor: "transparent",
                                                                                border: "none",
                                                                                color: "red",
                                                                                cursor: "pointer",
                                                                                fontSize: "14px",
                                                                            }}
                                                                        >
                                                                            ✕
                                                                        </button>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    )}

                    <div className="row">
                        <div className="col-sm-12 d-flex justify-content-between">
                            {/* 왼쪽 버튼 */}
                            <div style={{ marginLeft: "30px" }}>
                                {
                                    (id !== null && id !== "")
                                        ?
                                        <button type="button" className="btn btn-outline-danger" onClick={() => requestDelete(id)}>
                                            삭제
                                        </button>
                                        :
                                        <span></span>
                                }
                                <button
                                    type="button"
                                    className="btn btn-outline-dark"
                                    style={{ marginLeft: "10px" }}
                                    onClick={requestSendPushTest}>
                                    발송 테스트
                                </button>
                                {
                                    (content.sendType === "IMMEDIATE") && (
                                        <button
                                            type="button"
                                            className="btn btn-outline-success"
                                            style={{ marginLeft: "10px" }}
                                            onClick={requestSendPush}>
                                            즉시발송
                                        </button>
                                    )
                                }
                            </div>

                            {/* 오른쪽 버튼 */}
                            <div style={{ marginRight: "30px" }}>
                                <button type="button" className="btn btn-outline-secondary" onClick={() => navigate(-1)}>
                                    목록
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline-primary"
                                    style={{ marginLeft: "10px" }}
                                    onClick={requestSave}
                                >
                                    {id === null ? <span>저장</span> : <span>수정</span>}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div style={{ marginTop: "40px", marginLeft: "30px", color: "black" }}>
                        <div>- 즉시발송: 전송 방식이 즉시 발송일때만 노출되며, 지금 즉시 푸시를 전송합니다.</div>
                        <div>- 발송 테스트: 모트, 돈기부여, 원풍갈비, 싱글앤 싱글 사업장으로 지금 즉시 푸시를 전송합니다.</div>
                    </div>

                </div>
            </div>
        </div>
    )
}